// extracted by mini-css-extract-plugin
export var email = "ContactPerson-module--email--z-N0o";
export var name = "ContactPerson-module--name--zcq-S";
export var phone = "ContactPerson-module--phone--0QykV";
export var separator = "ContactPerson-module--separator--plvsz";
export var title = "ContactPerson-module--title--krh2G";